export enum StatusFinanceiroIntegration {
    CREATED='CREATED', WAITING='WAITING', CANCELED='CANCELED', ERROR='ERROR'
}
